
export const WorkingMode = {
    Live: "Live",
    Debug: "Debug",
    Test: "Test"
}